import { isEqual, isMatchWith, omit } from 'es-toolkit/compat'

import { Comment } from './comments-types'

export const isCommentsMatch = (commentsA: Comment[], commentsB: Comment[]) =>
  commentsA?.length === commentsB?.length &&
  isMatchWith(commentsA, commentsB, (a, b) => isEqual(omit(a, ['id']), omit(b, ['id'])))
